import { BotFlow, Dictionary, NlpIntent, NlpModel } from '@feedyou/schema'
import { Cell, Header, NlpModelSheets } from './types'
import {
  HeaderModelExampleKeys,
  HeaderModelIntentKeys,
  HeaderModelTriggerKeys,
  HeaderModelVariableKeys
} from './constants'

export function convertNlpModelsToXLS(tree: BotFlow): NlpModelSheets[] | undefined {
  return tree.nlp?.models?.map(getNlpModelSheetsFromModelIntents)
}

function getNlpModelSheetsFromModelIntents(model: NlpModel): NlpModelSheets {
  const nlpModelSheet = getInitNlpModelSheets(model.id)
  model?.intents?.forEach(intent => {
    const nlpIntent = intent as NlpIntent
    const intentRows = fillXlsRow(getIntentHeader(), {
      [HeaderModelIntentKeys.INTENT_ID]: intent.id,
      [HeaderModelIntentKeys.INTENT_TYPE]: intent?.type || 'intent',
      [HeaderModelIntentKeys.INTENT_NAME]: intent?.name || intent?.text
    })
    intentRows?.length && nlpModelSheet.intents.push(intentRows)

    nlpIntent?.rules?.forEach(rule => {
      const triggerRow = fillXlsRow(getTriggerHeader(), {
        [HeaderModelTriggerKeys.INTENT_ID]: intent.id,
        [HeaderModelTriggerKeys.RULE_TYPE]: rule?.type || '',
        [HeaderModelTriggerKeys.RULE_REGEX]: rule?.regex || ''
      })
      triggerRow?.length && nlpModelSheet.triggers.push(triggerRow)
    })

    nlpIntent?.utterances?.forEach(utterance => {
      const exampleRow = fillXlsRow(getExampleHeader(), {
        [HeaderModelExampleKeys.INTENT_ID]: intent.id,
        [HeaderModelExampleKeys.EXAMPLE_TEXT]: utterance || ''
      })
      exampleRow?.length && nlpModelSheet.examples.push(exampleRow)
    })

    nlpIntent?.variables?.forEach(variable => {
      const variableRow = fillXlsRow(getVariableHeader(), {
        [HeaderModelVariableKeys.INTENT_ID]: intent.id,
        [HeaderModelVariableKeys.VARIABLE_NAME]: variable?.name || '',
        [HeaderModelVariableKeys.VARIABLE_VALUE]: variable?.value || ''
      })
      variableRow?.length && nlpModelSheet.variables.push(variableRow)
    })
  })
  return nlpModelSheet
}

function fillXlsRow(header: string[], rowsByHeader: Dictionary<Header, Cell>): Cell[] {
  return header.map(cell => rowsByHeader[cell] || '')
}

function getInitNlpModelSheets(modelId: string): NlpModelSheets {
  const intents = [getIntentHeader()]
  const examples = [getExampleHeader()]
  const triggers = [getTriggerHeader()]
  const variables = [getVariableHeader()]

  return { modelId, intents, examples, triggers, variables }
}

function getIntentHeader(): typeof HeaderModelIntentKeys[keyof typeof HeaderModelIntentKeys][] {
  return Object.values(HeaderModelIntentKeys)
}

function getExampleHeader(): typeof HeaderModelExampleKeys[keyof typeof HeaderModelExampleKeys][] {
  return Object.values(HeaderModelExampleKeys)
}

function getTriggerHeader(): typeof HeaderModelTriggerKeys[keyof typeof HeaderModelTriggerKeys][] {
  return Object.values(HeaderModelTriggerKeys)
}

function getVariableHeader(): typeof HeaderModelVariableKeys[keyof typeof HeaderModelVariableKeys][] {
  return Object.values(HeaderModelVariableKeys)
}
